
import { IVersionInfo } from "../../domain/appVersion/IVersionInfo";
import { IVersionInfoRepository } from "../../domain/appVersion/IVersionInfoRepository";
import { restApiHelper } from "../helpers/RestApiHelper";

export class VersionInfoRepository implements IVersionInfoRepository {
    private _versionInfo: IVersionInfo | null = null;

    async getVersionInfo(): Promise<IVersionInfo> {
        if (!this._versionInfo) {

            const webApiInfo = await restApiHelper.getData("api/info", {});
            let version = "3.0.25056.9";

            if (version.charAt(0) === "$") {
                version = "1.0.0";
            }

            this._versionInfo = {
                webApiVersion: webApiInfo.sourceVersion,
                otapVersion: webApiInfo.otapVersion,
                appVersion: version
            };
        }
        return Promise.resolve(this._versionInfo);
    }
}

